module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/VANITY-FAIR_S01.546e052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/VANITY-FAIR_S01.jpg
// module id = mIku
// module chunks = 0